import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import useGetData from "../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../StoreComponents/hooks/useStoreLog";
import "./ViewRequisition.css";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const ViewRequisition = () => {
  const [limit, setLimit] = useState(50);
  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [viewRequisition, setViewRequisition] = useState([]);

  // Get View Requisition
  useEffect(() => {
    const getUsers = () => {
      API.get(`store/requisition/byId?page=${pageIndex}&limit=${limit}`, {
        headers: {
          search: `%${search}%`,
        },
      }).then(
        (res) => {
          setViewRequisition(res.data.data);
          setIsLoading(false);
        },

        (err) => {
          const mute = err;
          setHasError(true);
        }
      );
    };
    getUsers();
  }, [search, pageIndex, limit, isLoading]);

  const { requisitionUserNotification } = useGetData();
  const { mutate: mutate2 } = requisitionUserNotification();
  console.log(viewRequisition);

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
  };

  const handleAcceptUser = (requ_id) => {
    API.put("store/requisition/acceptByUser", {
      req_id: parseInt(requ_id),
    }).then((res) => {
      console.log(res);

      swal({
        title: "Thank You !",
        text: "Accepted Product",
        icon: "success",
        button: "Ok",
      });
      PostStoreLog(2, "requisition Accept by user");
      setIsLoading(true);
      mutate2();
    });
  };

  let count = 1;
  return (
    <>
      <Helmet>
        <title>View Requisition - BBA STORE</title>
        <meta name="description" content="View Requisition - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Manage Requisitions</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div">
              <div className="col-12 col-md-4 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-4 col-lg-4">
                <input
                  className="p-2 input-field_store w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search Requisitions"
                />
              </div>
            </div>
            {!viewRequisition ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive-sm data-table ">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th>S/N</th>
                      <th>Date & Time</th>
                      <th>Requisition ID</th>
                      <th>Required Products</th>
                      <th>Approved Products</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {viewRequisition.rows && (
                    <tbody>
                      {viewRequisition.rows.map((product) => (
                        <tr key={count}>
                          <th className="text-center">{count++}</th>
                          <td>
                            {moment(new Date(product.DATE_TIME)).format(
                              "LT , DD-MM-YYYY"
                            )}
                          </td>
                          <td className="text-center">
                            {product.REQUISITIONNO}
                          </td>
                          <td className="text-center">{product.PROREQUQTY}</td>
                          <td className="text-center">{product.APROQTY}</td>
                          <td className="text-center pt-2">
                            <span className="bg-success text-white px-3 py-1 rounded-3">
                              {product.Status}
                            </span>
                          </td>
                          <td className="text-center">
                            <Link
                              to={`/viewrequisitionstatus/${product.REQID}`}
                            >
                              <button
                                data-bs-toggle="tooltip"
                                title="View"
                                type="button"
                                className="btn btn-outline-color px-3"
                              >
                                <i className="fa fa-eye"></i>
                              </button>
                            </Link>
                            {product.Status === "Pending To Accept" && (
                              <button
                                data-bs-toggle="tooltip"
                                title="View"
                                type="button"
                                onClick={() => {
                                  handleAcceptUser(product.REQID);
                                }}
                                className="btn bg-success ms-2 text-white px-3"
                              >
                                <i className="fa fa-check "></i> Accept
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {viewRequisition.rows &&
                  (viewRequisition.rows.length === limit ? (
                    <button
                      type="button"
                      className="btn btn-outline-color_store px-4 me-2"
                      onClick={() => setPageIndex(pageIndex + 1)}
                    >
                      Next
                    </button>
                  ) : (
                    ""
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRequisition;
